// extracted by mini-css-extract-plugin
module.exports = {"panelLeft":"slot_booking-module__panelLeft___WdN+C","panelWrapper":"slot_booking-module__panelWrapper___4bavF"};